<template>
    <div class="room-listing">
        <filters :filters="filters"></filters>
        <listing-view :listings-type="listings" :theme="theme"></listing-view>
    </div>
</template>

<script>
    import Filters from '../../shared/Filters.vue';
    import ListingView from './ListingView.vue';
    import { Fragment } from 'vue-fragment';

    import { mapState, mapGetters, mapMutations } from 'vuex';

    export default {
        components: {
            Filters,
            ListingView,
            Fragment
        },

        props: ['listings', 'theme'],

        mounted() {
 
            this.updateListingsType(this.listings);
        },

        methods: {
            ...mapMutations('rooms', [
                'updateListingsType'
            ]),  
        },

        computed: {
            ...mapState('rooms', [ 
                'filters',
            ]),

            ...mapGetters('rooms', [
                'filteredListings',
            ]),

            hasListings() {
                return this.filteredListings.length > 0;
            }
        }
    }
</script> 